import { render, staticRenderFns } from "./_Relations.vue?vue&type=template&id=05b3018d&scoped=true&"
import script from "./_Relations.vue?vue&type=script&lang=js&"
export * from "./_Relations.vue?vue&type=script&lang=js&"
import style0 from "./_Relations.vue?vue&type=style&index=0&id=05b3018d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3018d",
  null
  
)

export default component.exports